<template>
  <!-- eslint-disable -->
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    style="enable-background: new 0 0 100 100;"
    xml:space="preserve"
  >
    <circle
      cx="50" cy="50" r="50"
      fill="#3e3a94"
    />

    <path
      fill="#f7f6f7"
      d="M72.7,31.7l3-8c0.4-0.9-0.2-1.7-1.1-1.7H38.3c-0.5,0-0.9,0.3-1.1,0.8l-4.1,10.1c0,0-0.1,0.2-0.1,0.4
  v43.6c0,1.3,0.6,1.9,1.2,1.9h9.6c0.7,0,1.2-0.6,1.2-1.2V57c0-0.7,0.6-1.2,1.2-1.2h16c0.5,0,1-0.3,1.2-0.8l3.2-7.9
  c0.3-0.8-0.2-1.7-1.2-1.7H46.3c-0.7,0-1.2-0.6-1.2-1.2V33.7c0-0.7,0.6-1.2,1.2-1.2h25.2C72,32.4,72.5,32.1,72.7,31.7z"
    />
  </svg>
  <!-- eslint-enable -->
</template>

<script>
  export default {
    name: 'FrejaEidOval'
  }
</script>
